import { render, staticRenderFns } from "./AutomatedEmails.vue?vue&type=template&id=68137ffa&scoped=true&"
import script from "./AutomatedEmails.vue?vue&type=script&lang=js&"
export * from "./AutomatedEmails.vue?vue&type=script&lang=js&"
import style0 from "./AutomatedEmails.vue?vue&type=style&index=0&id=68137ffa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68137ffa",
  null
  
)

export default component.exports